import { jsx as _jsx } from "react/jsx-runtime";
import * as S from './MaturedChip.css';
const MaturedChip = ({ size = 'medium', variant = 'filled', textTransform = 'uppercase', label = 'Matured', }) => (_jsx(S.MaturedChip, { label: label, variant: variant, color: "secondary", size: size, texttransform: textTransform }));
export default MaturedChip;
